import styled from 'styled-components';
import { COLOURS, isFocused } from '@belong/themes';
import { ButtonUnstyled, Icon, withLink } from '@belong/ui-components';
import { HEIGHT_WITH_UNIT } from '../GlobalHeaderMobile/styles';

export const StyledIconWithDot = styled(Icon)<{ isDesktop?: boolean }>`
  position: relative;
  vertical-align: middle;
  margin: ${({ isDesktop }) => (isDesktop ? '0 0.8rem 0 0' : '0')};

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: -0.2rem;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: ${COLOURS.DISCO_PINK_DARK};
    pointer-events: none;
  }
`;

export const MobileCartButtonWrapper = withLink(styled(ButtonUnstyled)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${HEIGHT_WITH_UNIT};
  width: ${HEIGHT_WITH_UNIT};
  cursor: pointer;

  &:focus {
    ${() => isFocused(true)}
  }
`);
